import { Component, Input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@nagel-assests';
import { sidenavLink } from '@nagel-types';

@Component({
    selector: 'lib-sidenav-link',
    imports: [
        MatListModule,
        RouterLink,
        RouterLinkActive,
        IconComponent,
    ],
    templateUrl: './sidenav-link.component.html',
    styleUrl: './sidenav-link.component.scss'
})
export class SidebarNavigationComponent {
        @Input() collapsed!: boolean;
        @Input() navigationItem!: sidenavLink;
        @Input() isActive!: boolean;
}